import React from 'react'
import './css/Projects.css'
import toDo from './images/toDo.jpg'
import delivary from './images/delivary.png'
import profileCard from './images/profileCard.webp'

function Projects() {
  return (
    <div>

<section id="projects">
        <div className="container">
            <h2 className="section-heading" data-outline="Projects">Projects</h2>
            <div className="all-items">
                <div className="item">
                    <div className="left">
                        <div className="img">
                            <img src={delivary} alt="" />
                        </div>
                    </div>
                    <div className="right">
                        <h2 className="project-title">foodlaza</h2>
                        <h3 className="project-sub-title">Food Delivery Website</h3>
                        <p className="project-desc">
                            Self made website build with html, css and Javascript on Visual Studio Code.
                            This is Front-end Website.
                        </p>
                        <div className="buttons">
                            <a href="https://foodlaza.netlify.app/" className="primary-btn">Live Demo</a>
                            <a href="https://github.com/subhadip000/food-delivery--Subha" className="primary-btn outline external-link"> <span>Source Code</span>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                            </a>
                        </div>

                    </div>
                </div>
                <div className="item">
                    <div className="left">
                        <div className="img">
                            <img src={profileCard} alt="" />
                        </div>
                    </div>
                    <div className="right">
                        <h2 className="project-title">Profile Card</h2>
                        <h3 className="project-sub-title">A website for profile card.
                        </h3>
                        <p className="project-desc">
                            Self made profile card using html and css on Visual Studio Code.
                        </p>
                        <div className="buttons">
                            <a href="https://subhadip-profilecard.netlify.app/" className="primary-btn">Live Demo</a>
                            <a href="https://github.com/subhadip000/Subhadip-Profile-Card" className="primary-btn outline external-link"> <span>Source Code</span>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="item">
                    <div className="left">
                        <div className="img">
                            <img src={toDo} alt="" />
                        </div>
                    </div>
                    <div className="right">
                        <h2 className="project-title">To Do List</h2>
                        <h3 className="project-sub-title">To Do List Website</h3>
                        <p className="project-desc">
                            Self made To Do List using React on Visual Studio Code.
                        </p>
                        <div className="buttons">
                            <a href="https://to-do-list-subhadip.netlify.app/" className="primary-btn">Live Demo</a>
                            <a href="https://github.com/subhadip000/ToDo-List" className="primary-btn outline external-link"> <span>Source Code</span>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    </div>
  )
}

export default Projects